import { gql } from 'graphql-tag'

/**
 * ATTEND NOW / ATTEND LATER — a case's rank inside the day it is planned for.
 *
 * Deliberately its own mutation, not a flag on `setCasePlan`: re-ranking a
 * case within today and moving it to another day are different intentions,
 * and the backend keeps them apart so one can't become the other.
 *
 * Resolves to the updated plan `{ id, plannedFor, priority, ... }`, or null
 * when the caller has no plan for that case.
 */
export const SET_CASE_PLAN_PRIORITY_MUTATION = gql`
  mutation SetCasePlanPriority($caseId: ID!, $priority: Int!) {
    setCasePlanPriority(caseId: $caseId, priority: $priority)
  }
`

/**
 * SET ALL TO ATTEND NOW — the /cases blank-area menu. Every plan of MINE in
 * "Attend later" goes back to now at once, loaded or not; resolves to
 * `{ caseIds }`, the cases the server actually changed.
 */
export const RESET_MY_CASE_PLAN_PRIORITIES_MUTATION = gql`
  mutation ResetMyCasePlanPriorities {
    resetMyCasePlanPriorities
  }
`
